// extracted by mini-css-extract-plugin
export var button = "_c0-4";
export var hasDarkBackground = "_c0-7";
export var hasLightBackground = "_c0-6";
export var iconWrapper = "_c0-0";
export var large = "_c0-2";
export var medium = "_c0-1";
export var small = "_c0-5";
export var xsmall = "_c0-3";